import Tools from "../views/Systems/Tools";
import ToolUptimeReportView from "../views/Systems/ToolUptimeReportView";
import ToolView from "../views/Systems/ToolView";
import ToolProcessView from "../views/Systems/ToolProcessView";
import ToolRecentRunsView from "../views/Systems/ToolRecentRunsView";
import ToolStateHistoryView from "../views/Systems/ToolStateHistoryView";

export default [
  {
    path: "/Tools",
    name: "Tools",
    component: Tools
  },
  {
    path: "/ToolReports",
    name: "ToolUptimeReportView",
    component: ToolUptimeReportView
  },
  {
    path: "/Tools/:name",
    name: "ToolDetail",
    component: ToolView,
    props: true,
    children: [
      {
        path: "Processing",
        component: ToolProcessView,
        name: "ToolProcessView",
        props: true
      },
      {
        path: "ProcessHistory",
        component: ToolRecentRunsView,
        name: "ToolRecentRunsView",
        props: true
      },
      {
        path: "UpTimeHistory",
        component: ToolStateHistoryView,
        name: "ToolStateHistoryView",
        props: true
      }
    ]
  }
]